import { Typography } from 'antd'
import styled from 'styled-components'
import { FormDescription } from '../../FormComponent'
import { QuestionLayout } from '../types'
import { COLUMN_GAP } from '../constants'

interface LabelAndDescriptionFieldLayoutProps {
  label?: React.ReactNode
  secondaryText?: string
  children: React.ReactNode
  layout?: QuestionLayout
}

const { Text } = Typography

const LabelAndDescriptionFieldLayout = ({
  label,
  secondaryText,
  children,
  layout = QuestionLayout.HORIZONTAL
}: LabelAndDescriptionFieldLayoutProps): JSX.Element => {
  const isHorizontal = layout === QuestionLayout.HORIZONTAL
  const hasDescription = Boolean(secondaryText)

  return (
    <Container isHorizontal={isHorizontal}>
      <LabelContainer isHorizontal={isHorizontal}>
        {label && <Text strong>{label}</Text>}
        {hasDescription && <FormDescription text={secondaryText} />}
      </LabelContainer>
      <FieldContainer isHorizontal={isHorizontal}>{children}</FieldContainer>
    </Container>
  )
}

const LabelContainer = styled.div<{ isHorizontal: boolean }>`
  width: ${({ isHorizontal }) => (isHorizontal ? '50%' : '100%')};
  margin: ${({ isHorizontal }) => (isHorizontal ? '0 0 8px' : '0 0 12px')};
`

const FieldContainer = styled.div<{ isHorizontal: boolean }>`
  width: ${({ isHorizontal }) => (isHorizontal ? '50%' : '100%')};
  margin: 0 0 8px;
`

const Container = styled.div<{ isHorizontal: boolean }>`
  display: flex;
  flex-direction: ${({ isHorizontal }) => (isHorizontal ? 'row' : 'column')};

  gap: ${({ isHorizontal }) => (isHorizontal ? COLUMN_GAP : '0')};
`

export default LabelAndDescriptionFieldLayout
